import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Entity } from 'src/app/shared/entity-search/entity-search.service';
import { EntityRef, EntityType } from 'src/app/core/settings/settings.service';

@Component({
  selector: 'settings-breadcrumbs',
  templateUrl: './settings-breadcrumbs.component.html',
  styleUrls: ['./settings-breadcrumbs.component.scss']
})
export class SettingsBreadcrumbs {

  @Input() highlightedEntityId: string;
  @Input() selectedEntity: Entity;
  @Output() breadcrumbSelect: EventEmitter<Entity> = new EventEmitter<Entity>();
  @Output() searchWithin: EventEmitter<EntityRef> = new EventEmitter<Entity>();

  company: EntityRef;

  ngOnChanges() {
    if(this.selectedEntity) {
      this.company = this.selectedEntity.path
      .find(e => e.entityType === EntityType.company);
    }
  }

  setEntity(entity: Entity) {
    this.selectedEntity = entity;
    this.company = this.selectedEntity.path
      .find(e => e.entityType === EntityType.company);
  }

  searchWithinCompany(): void {
    this.searchWithin.emit(this.company);
  }

  public selectBreadcrumb(ref: EntityRef) {

    let breadcrumbPath = this.selectedEntity.path;
    while (breadcrumbPath.at(breadcrumbPath.length - 1).id != ref.id && breadcrumbPath.length > 1) {
      breadcrumbPath = breadcrumbPath.slice(0, -1);
    }

    let breadcrumbEntity: Entity = {
      id: ref.id,
      name: ref.name,
      entityType: ref.entityType,
      rootGroupId: this.selectedEntity.rootGroupId,
      path: breadcrumbPath
    };
    this.breadcrumbSelect.emit(breadcrumbEntity);
  }

  getIcon(entityType: string): string {
    if (entityType === EntityType.stack) {
      entityType = EntityType.default;
    }
    return "../../assets/images/settings/" + entityType.toLowerCase() + ".svg";
  }
}


